<template>
	<div class="scoped-index" v-if="firstRendered">
		<div
			class="index-count-bar box-shadow-small border-radius"
		>
			<div v-for="(item, index) in tasks" :key="index" :data-type="item.type">
				<div class="count-item">
					<p class="index-summary-title">
						<i :class="[item.className, 'mr-5']"></i>
						{{item.taskName}}
						<span class="ml-15">{{ item.taskNum }}</span>
					</p>
					<el-row type="flex">
						<el-col
							v-for="(subItem, index) in item.taskCount"
							:key="index"
							:span="24/item.taskCount.length"
						>
							<el-row :class="{'interview-list-set': index > 0}" v-if="item.type === '2'">
								<p class="interview-text">
									<strong>{{subItem.arrangeText}}</strong>
									<router-link :to="item.urls[index][0]">
										<span class="ml-5 color-primary">
											<small>未安排：</small>
											{{subItem.notArrange}}
										</span>
									</router-link>
									<router-link :to="item.urls[index][1]">
										<span class="ml-5 color-primary">
											<small>已安排：</small>
											{{subItem.arranged}}
										</span>
									</router-link>
								</p>
								<el-col v-for="(listItem, listIndex) in subItem.list" :key="listIndex" :span="6">
									<router-link
										v-if="item.childrenUrls[index][listIndex]"
										:to="item.childrenUrls[index][listIndex]"
									>
										<p class="total-num">{{listItem.taskNum}}</p>
										<small v-html="listItem.taskName.replace('&', '&<br/>')"></small>
									</router-link>
									<template v-else>
										<p class="total-num">{{listItem.taskNum}}</p>
										<small v-html="listItem.taskName.replace('&', '&<br/>')"></small>
									</template>
								</el-col>
							</el-row>
							<template v-else>
								<router-link v-if="item.urls[index]" :to="item.urls[index]">
									<p class="mt-20 total-num">{{subItem.taskNum}}</p>
									<p class="sub-title">{{ subItem.taskName }}</p>
								</router-link>
								<template v-else>
									<p class="mt-20 total-num">{{subItem.taskNum}}</p>
									<p class="sub-title">{{ subItem.taskName }}</p>
								</template>
							</template>
						</el-col>
					</el-row>
				</div>
			</div>
		</div>
		<div class="filter-result background-white box-shadow-small border-radius">
			<div class="clearfix mb-15">
				<export-custom-dialog :showChoosedButton="false" :params-call-back="customExportParams" class="pull-right ml-10"></export-custom-dialog>
				<el-button
					icon="el-icon-my-daochu"
					type="info"
					@click="exportParamsFiles('/resume/exportAllResumeUnlimited.api')"
					class="pull-right"
				>导出所有查询结果</el-button>
			</div>
			<div class="search-box mt-20 hide">
				<el-button class="search-hd" type="primary" icon="el-icon-search" @click="searchKeyword(keyword)"></el-button>
				<div class="search-bd">
					<search-bar
						v-model="keyword"
						@enter-key="searchKeyword"
						@select="searchKeyword"
						:ajaxSearch="false"
						placeholder="请输入应聘者姓名、职位名称、手机号、邮箱进行搜索"
					></search-bar>
				</div>
			</div>
			<multi-search></multi-search>
			<div class>
				<div class="filter-result" v-loading="partialLoading">
					<empty-tip :show="!lists.length"></empty-tip>
					<div class="table-list">
						<el-table border v-if="lists.length" :data="lists" style="width: 100%">
							<el-table-column
								label="姓名"
								:show-overflow-tooltip="true"
								align="center"
								fixed
								min-width="100"
							>
								<template slot-scope="scope">
                  <span class="name-txt" @click="toResumeDetail(scope.row)">
                    {{ scope.row.resumeForm.name }}
                  </span>
								</template>
							</el-table-column>
							<el-table-column
								prop="resumeForm.gender"
								label="性别"
								:show-overflow-tooltip="true"
								align="center"
								min-width="60"
							>
								<template slot-scope="scope">{{{1: '男', 2: '女'}[scope.row.resumeForm.gender] || '-'}}</template>
							</el-table-column>
							<el-table-column
								prop="positionForm.name"
								label="岗位"
								:show-overflow-tooltip="true"
								align="center"
								min-width="140"
							></el-table-column>
							<el-table-column
								prop="positionForm.deptNames"
								label="招聘部门"
								:show-overflow-tooltip="true"
								align="center"
								width="95"
							></el-table-column>
							<el-table-column
								prop="resumeForm.mobilePhone"
								:show-overflow-tooltip="true"
								label="手机号"
								align="center"
								min-width="130"
							></el-table-column>
							<el-table-column
								prop="resumeForm.email"
								:show-overflow-tooltip="true"
								label="邮箱"
								align="center"
								min-width="130"
							>
								<template slot-scope="scope">{{ scope.row.resumeForm.email || '-' }}</template>
							</el-table-column>
							<el-table-column
								prop="resumeForm.resumeMaxEducation.major"
								label="最高学历"
								:show-overflow-tooltip="true"
								align="center"
								min-width="90"
							>
								<template slot-scope="scope">
									{{ getSelectMapText('WB_EDU_DEGREE', scope.row.resumeForm.resumeMaxEducation.degree)
									}}
								</template>
							</el-table-column>
							<el-table-column
								prop="resumeForm.resumeMaxEducation.school"
								label="最高学历学校"
								:show-overflow-tooltip="true"
								align="center"
								min-width="140"
							></el-table-column>
							<el-table-column
								prop="resumeForm.resumeMaxEducation.major"
								label="专业"
								:show-overflow-tooltip="true"
								align="center"
								min-width="140"
							></el-table-column>
							<el-table-column
								prop="source"
								:show-overflow-tooltip="true"
								label="简历来源"
								align="center"
								min-width="120"
							>
								<template slot-scope="scope">
									{{scope.row.resumeForm && transToText('WB_RESUME_SOURCE',
									scope.row.resumeForm.resumeSource)}}
								</template>
							</el-table-column>
							<el-table-column
								prop="positionForm.sourceFrom"
								label="招聘来源"
								:show-overflow-tooltip="true"
								align="center"
								min-width="100"
							>
								<template slot-scope="scope">
									{{scope.row.resumeForm && transToText('WB_SOURCE_FROM',
									scope.row.resumeForm.sourceFrom)}}
								</template>
							</el-table-column>
							<el-table-column label="应聘城市" :show-overflow-tooltip="true" align="center" min-width="80">
								<template
									slot-scope="scope"
								>{{ getSelectMapText('WB_POSITION_CITY', scope.row.resumeForm.expectCityId)}}</template>
							</el-table-column>
							<el-table-column
								prop="positionForm.sourceFrom"
								label="投递渠道"
								:show-overflow-tooltip="true"
								align="center"
								min-width="100"
							>
								<template slot-scope="scope">
									{{scope.row.resumeForm && transToText('WB_ADD_SOURCE',
									scope.row.resumeForm.addSource)}}
								</template>
							</el-table-column>
							<el-table-column
								label="投递人"
								prop="resumeForm.addName"
								:show-overflow-tooltip="true"
								align="center"
								min-width="80"
							></el-table-column>
							<el-table-column label="推荐人" :show-overflow-tooltip="true" align="center" min-width="80">
								<template slot-scope="scope">
									<span
										v-if="scope.row.resumeForm.recommenderUser"
									>{{scope.row.resumeForm.recommenderUser.name}}</span>
								</template>
							</el-table-column>
							<el-table-column
								prop="positionForm.mark"
								:show-overflow-tooltip="true"
								label="招聘HR"
								align="center"
								min-width="80"
							></el-table-column>
							<el-table-column label="简历附件" align="center" width="120">
								<template slot-scope="scope">
									<attach-view-in-list :attachList="scope.row.resumeForm.resumeAttachList"></attach-view-in-list>
								</template>
							</el-table-column>
							<el-table-column align="center" label="投递时间" :show-overflow-tooltip="true" min-width="100">
								<template slot-scope="scope">{{dateFormat(scope.row.commitTime)}}</template>
							</el-table-column>

							<el-table-column
								prop="status"
								:show-overflow-tooltip="true"
								label="状态"
								align="center"
								min-width="130"
							>
								<template slot-scope="scope">
									<el-tooltip
										effect="dark"
										:content="scope.row.operateReason"
										placement="top-start"
										v-if="scope.row.operateReason"
									>
										<el-button type="text" icon="el-icon-my-xinxi">
											{{getStatusText(scope.row)}}
										</el-button>
									</el-tooltip>
									<span v-else>{{getStatusText(scope.row)}}</span>
								</template>
							</el-table-column>
							<el-table-column
								prop="resumeForm.remark"
								:show-overflow-tooltip="true"
								label="备注"
								align="center"
								min-width="120"
							>
								<template slot-scope="scope">
									<remark-edit :id="scope.row.resumeForm.id" v-model="scope.row.resumeForm.remark"></remark-edit>
								</template>
							</el-table-column>
							<el-table-column
								prop="lastOperateUserInfo.remark"
								:show-overflow-tooltip="true"
								label="最近操作人"
								align="center"
								min-width="120"
							>
								<template slot-scope="scope">
									<div style="font-size: 12px;">
										<p>
											{{scope.row.lastOperateUserInfo ? scope.row.lastOperateUserInfo.name :
											''}}
										</p>
										<p>{{scope.row.lastOperateTime && scope.row.lastOperateTime.slice(5)}}</p>
									</div>
								</template>
							</el-table-column>
						</el-table>
					</div>
					<el-pagination
						v-if="lists.length"
						class="text-center mb-20 mt-20"
						@size-change="pageSizeChange"
						@current-change="pageIndexChange"
						:current-page="pagination.pageIndex"
						:page-size="pagination.pageSize"
						layout="total, sizes, prev, pager, next, jumper"
						:total="pagination.recordCounts"
					></el-pagination>
				</div>
			</div>
		</div>
	</div>
</template>
<script type="text/javascript">
import QueryListExtend from 'components/queryListExtend'
import operationMixin from '../operation/operationMixin'
import selectMapMixin from 'mixins/selectMapMixin'
import AttachViewInList from '../operation/attachViewInList.vue'
import RemarkEdit from '../operation/remarkEditDialog.vue'
import axios from 'axios'
import _ from 'underscore'
import { dateFormat } from 'modules/tools'
import MultiSearch from 'views/common/multiSearch'

export default {
    components: {
        AttachViewInList,
        RemarkEdit,
        MultiSearch
    },
    data() {
        return {
            fetchUrl: '/desktop/task/list.api',
            tasks: [],
            searchData: {
                searchWord: null
            },
            searchInputIcon: '',
            tableData: [],
            tasksExtend: {
                '0': {
                    urls: [
                        '/resume?statusSearch=000',
                        '/resume?statusSearch=001',
                        '/resume?statusSearch=002,003',
                        ''
                    ],
                    className: 'el-icon-my-daichulijianli color-success'
                },
                '1': {
                    urls: [
                        '/written?resumeStatus=010',
                        '/written?resumeStatus=011,012,013',
                        '/written?resumeStatus=014',
                        ''
                    ],
                    className: 'el-icon-my-luyonghuanjie color-purple'
                },
                '2': {
                    urls: [
                        [
                            '/interview/1?interviewStatusSearch=2',
                            '/interview/1?interviewStatusSearch=1'
                        ],
                        [
                            '/interview/2?interviewStatusSearch=2',
                            '/interview/2?interviewStatusSearch=1'
                        ],
                        [
                            '/interview/3?interviewStatusSearch=2',
                            '/interview/3?interviewStatusSearch=1'
                        ],
                        [
                            '/interview/4?interviewStatusSearch=2',
                            '/interview/4?interviewStatusSearch=1'
                        ]
                    ],
                    childrenUrls: [
                        [
                            '/interview/1?statusSearch=020,021',
                            '/interview/1?statusSearch=022',
                            '',
                            '/interview/1?statusSearch=024,023'
                        ],
                        [
                            '/interview/2?statusSearch=120,121',
                            '/interview/2?statusSearch=122',
                            '',
                            '/interview/2?statusSearch=124,123'
                        ],
                        [
                            '/interview/3?statusSearch=220,221',
                            '/interview/3?statusSearch=222',
                            '',
                            '/interview/3?statusSearch=224,223'
                        ],
                        [
                            '/interview/4?statusSearch=320,321',
                            '/interview/4?statusSearch=322',
                            '',
                            '/interview/4?statusSearch=324,323'
                        ]
                    ],
                    className: 'el-icon-my-mianshihuanjie color-info'
                },
                '3': {
                    urls: [
                        '/salary?statusSearch=030',
                        '/salary?statusSearch=032',
                        '/salary?statusSearch=040'
                    ],
                    className: 'el-icon-my-mianshipinggu color-primary'
                },
                '4': {
                    urls: [
                        '/entry?statusSearch=040',
                        '/entry?statusSearch=042',
                        '/entry?statusSearch=050'
                    ],
                    className: 'el-icon-my-ruzhihuanjie color-primary'
                }
            }
        }
    },
    extends: QueryListExtend,
    mixins: [operationMixin, selectMapMixin],
    computed: {
        selectMap() {
            return this.$store.state.baseData.selectMap
        },
        hasSalary() {
            return this.$store.state.user.paymentFlag
        },
        hasWritten() {
            return this.$store.state.user.writtenFlag
        },
        interviewData() {
            let data = this.tasks.filter(item => item.type === '2')
            let result = []
            if (data.length) {
                data = data[0]
                data.taskCount.forEach((item, index) => {
                    if (index % 5 === 0) {
                        item.children = []
                        result.push(item)
                    } else {
                        let order = Math.floor(index / 5)
                        result[order] && result[order].children.push(item)
                    }
                })
            }
            console.log(result)
            return result
        }
    },
    methods: {
        dateFormat(date, format = 'yyyy/MM/dd') {
            return dateFormat(date, format)
        },
        transToText(base, value) {
            let target = _.findWhere(this.selectMap[base], { value: value + '' })
            return (target && target.text) || ''
        },
        getStatusText(row) {
            if (row.isJobTransfer == 1) {
                return '已转岗'
            }

            return this.transToText('WB_FLOW_STATUS', row.status)
        },
        colSpan(index) {
            let colSpanArr = []
            if (this.hasWritten) {
                if (this.hasSalary) {
                    colSpanArr = [3, 4, 12, 3, 3]
                } else {
                    colSpanArr = [4, 4, 12, 4]
                }
            } else {
                if (this.hasSalary) {
                    colSpanArr = [4, 12, 4, 4]
                } else {
                    colSpanArr = [5, 14, 5]
                }
            }
            // console.log('colSpan', colSpanArr, index, colSpanArr[index])
            return colSpanArr[index]
        },
        getInterviewTurn(status) {
            let phase = status.slice(1, 2)
            if (phase === '2') {
                return Number(status.slice(0, 1)) + 1
            }
            return undefined
        },
        getPhaseName(status) {
            let phase = +status.slice(1, 2)
            return [
                'resumeList',
                'writtenList',
                'interviewList',
                '',
                'entryList',
                'entryList'
            ][phase]
        },
        toResumeDetail(row) {
            const phaseName = this.getPhaseName(row.status)
            const turn = this.getInterviewTurn(row.status)
            const path = this.getResumeDetailUrl(row.id, row.status, phaseName) + `&turn=` + turn
            const routeData = this.$router.resolve({ path })
            window.open(routeData.href, '_blank')
        }
    },
    created() {
        axios
            .get('/desktop/task/statistics.api')
            .then(res => {
                let temp = { urls: [], className: '' }
                res.result.list.map((item, index) => {
                    Object.assign(item, this.tasksExtend[item.type] || temp)
                    if (item.type === '2') {
                        item.taskCount = ['1', '2', '3', '4'].map(interviewIndex => {
                            let temp = []
                            item.taskCount.forEach(taskItem => {
                                if (taskItem.type === interviewIndex) {
                                    temp.push(taskItem)
                                }
                            })
                            return {
                                arrangeText: `${interviewIndex} 面`,
                                notArrange: temp[0].taskNum,
                                arranged: temp[1].taskNum,
                                list: temp.splice(2)
                            }
                        })
                    }
                })

                this.tasks = res.result.list
            })
            .catch(console.error)
    }
}
</script>
<style lang="scss">
@import "~variable";
@import "~style/base/mixin";

.index-count-bar {
	margin-top: 0px;
	padding: 20px 0;
	@include clearfix;
	display: flex;
	> div {
		margin-right: -1px;
		padding: 0 5px;
		flex: 1;
		&:not(:last-child) {
			border-right: 1px solid $border-color;
		}
		&[data-type="2"] {
			flex: 4;
		}
	}
	.todo-icon {
		margin-left: 5px;
		background: #50bfff;
		color: #fff;
		font-size: 12px;
		padding: 0 5px;
		border-radius: 50px;
	}
	.count-item {
		text-align: center;
		
		color: #6f7b91;
		> .el-row {
			margin-top: 15px;
		}
		.index-summary-title {
			font-size: 18px;
			font-weight: bold;
		}
		[class^="el-icon-my-"] {
			font-size: 26px;
			vertical-align: middle;
		}
		.el-icon-my-mianshipinggu {
			font-size: 19px;
		}
		.sub-title {
			color: #6f7b91;
		}
		.total-num {
			font-size: 19px;
			color: $text-color;
		}

		.interview-text {
			color: #6f7b91;
		}
		small {
			color: #6f7b91;
		}
	}
	.interview-list-set {
		border-left: 1px solid $border-color;
	}
}
</style>



// WEBPACK FOOTER //
// index.vue?dd34c3b4